import React, { useState, useEffect } from "react";
import About from "../pages/About";
import AboutMobile from "../pages/About_mobile";

const AboutWrapper = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Check on initial load
    checkScreenSize();

    // Add event listener
    window.addEventListener("resize", checkScreenSize);

    // Clean up event listener
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  return (
    <>
      {isMobile ? <AboutMobile /> : <About />}
    </>
  );
};

export default AboutWrapper;